import React, { Component } from "react";
import { connect } from "react-redux";
import { actualizarMensaje, mostrarModulo } from "../../redux/actions/actGlobal";
import { withStyles } from '@material-ui/core/styles';
import { obtenerValoresFiltros, consulta } from "../../global/js/funciones";
import MenuAcompanamiento from './MenuAcompanamiento';
import NuevoReporte from './NuevoReporte';
import ProcesosDocente from './ProcesosDocente';
import Historial from './Historial';
import InicioNuevo from './InicioNuevo';
import {ESTADO} from "./helper";
const styles = (theme) => ({
  container: {
    padding: '20px',
    maxWidth: '1200px',
    margin: '0 auto',
    width: '95%'
  }
});

class AcompanamientoDocente extends Component {
  constructor(props) {
    super(props);
    this.state = {
      seccionActiva: 'procesos',
      periodo: '',
      notificaciones: []
    };
  }

  async componentDidMount() {
    const { mostrarModulo } = this.props;
    mostrarModulo({ ruta: "/acompanamiento_docente", nombre: "Acompañamiento Docente" });
    await this.obtenerPeriodo();
    await this.obtenerNotificaciones();
  }

  obtenerPeriodo = async () => {
    let periodo = await obtenerValoresFiltros([{ 'llave': 'codigo', 'valor': 'Per_Acomo_docen_Sol' }, { 'llave': 'estado', 'valor': ESTADO }]);
    this.setState({ periodo: periodo.length > 0 ? periodo[0].nombre : '' });
  }

  obtenerNotificaciones = async () => {
    consulta('api/v1.0/acompanamiento_docente/estudiantes-reportados', null, null, (error, estado, resp) => {
      if (!error && estado === 200) {
        this.setState({ notificaciones: resp || [] });
      } else {
        console.error('Error al obtener notificaciones:', error);
        this.setState({ notificaciones: [] });
      }
    });
  }

  seleccionarSeccion = (seccion) => {
    this.setState({ seccionActiva: seccion });
  };

  handleMessage = (mensaje) => {
    this.props.actualizarMensaje(mensaje);
  };

  handleCrearReporte = () => {
    this.setState({ seccionActiva: 'nuevo-reporte' });
  };

  renderContenido = () => {
    const { seccionActiva } = this.state;
    
    switch (seccionActiva) {
      case 'procesos':
        return <ProcesosDocente periodo={this.state.periodo} />;
      case 'nuevo':
        return <InicioNuevo onCrearReporte={this.handleCrearReporte} />;
      case 'historial':
        return <Historial />;
      case 'nuevo-reporte':
        return <NuevoReporte onMessage={this.handleMessage} />;
      default:
        return <NuevoReporte onMessage={this.handleMessage} />;
    }
  };

  render() {
    const { classes } = this.props;
    const { seccionActiva } = this.state;

    return (
      <div>
        <MenuAcompanamiento 
          sele={seccionActiva} 
          seleccionar={this.seleccionarSeccion}
          notificaciones={this.state.notificaciones}
        />
        <div className="contenido_modulo">
          <div className={classes.container}>
            {this.renderContenido()}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = {
  actualizarMensaje,
  mostrarModulo
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AcompanamientoDocente));
